var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCartSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0488281,6.9609375C29.5722656,6.3505859,28.8535156,6,28.0791016,6H5.7803345L4.8486328,2.2714844 C4.5146484,0.9345703,3.3173828,0,1.9384766,0H0v2h1.9384766C2.3984375,2,2.796875,2.3115234,2.9091797,2.7568359 l5.2421875,20.9716797C8.4853516,25.0654297,9.6826172,26,11.0615234,26H26v-2H11.0615234 c-0.4599609,0-0.8583984-0.3115234-0.9707031-0.7568359L9.2802124,20h16.1582642 c1.3789062,0,2.5761719-0.9345703,2.9101562-2.2724609l2.15625-8.6210938 C30.6923828,8.3535156,30.5263672,7.5722656,30.0488281,6.9609375z M26.4091797,17.2421875 C26.296875,17.6884766,25.8984375,18,25.4384766,18H8.78125l-2.5-10h21.7978516 c0.2119141,0,0.3378906,0.1201172,0.3935547,0.1923828c0.0566406,0.0712891,0.1425781,0.2236328,0.0917969,0.4296875 L26.4091797,17.2421875z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartSmall);
export default __webpack_public_path__ + "static/media/shopping-cart--small.5c212c45158362da7602c05620ebaac8.svg";
export { ForwardRef as ReactComponent };